import { Component, OnInit } from '@angular/core';
import { PostsService } from '../modules/core/services/posts.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-not-active',
  templateUrl: './not-active.component.html',
  styleUrls: ['./not-active.component.scss']
})
export class NotActiveComponent implements OnInit {


  constructor(
    private router:Router,
    public postsService: PostsService,
  )
  {}





ngOnInit(): void {




}
}






